'use client';
import Tag from "./Tag.js";
export default Tag;